import { useDispatch, useSelector } from 'react-redux'

type UseModalParams = {
  selector: (state: any) => any
  actionCreator: (payload: any) => any
  modalKey: string
}

const useModal = ({ selector, actionCreator, modalKey }: UseModalParams) => {
  const dispatch = useDispatch()
  const config = useSelector(selector)
  const isOpen = config?.[modalKey] ?? false

  const openModal = () => dispatch(actionCreator({ [modalKey]: true }))
  const closeModal = () => dispatch(actionCreator({ [modalKey]: false }))

  return { isOpen, openModal, closeModal }
}

export default useModal
